/**
 * Middleware application layer, handling asynchronous call to GEO internal API.
 * @module geo/middleware
 * @private
 * @internalapi
 * @preferred
 */
/**
 * @preferred
 */
import 'rxjs';

import {combineEpics} from 'redux-observable';

import {reduxPromiseObservableEpic} from '../helpers/observable.to.promise';

import {addMenuItemEpic} from './add.menu.item.epic';  // ADD IMPORT HERE
import {setBaselayersVisibilityEpic} from './base.layers.visibility.epic';
import {setComponentsStateEpic} from './components.state.epic';
import {dispatchDataRefreshEventEpic} from './data.refresh.event.epic';
import {disableFunctionalityEpic, enableFunctionalityEpic} from './functionality.epics';
import {initialiseEpic} from './initialise.epic';
import {gotoExtentEpic, gotoInitExtentEpic, gotoPointEpic, pantToEpic, zoomInEpic, zoomOutEpic, zoomToScaleEpic} from './localisation.epics';
import {listMapEventsEpic} from './map.events.epic';
import {addMarkersEpic, gotoMarkerEpic, removeMarkersEpic} from './markers.epics';
import {registerExtensionEpic} from './register.extension.epic';
import {addToSelectionEpic, removeFromSelectionEpic, resetSelectionEpic} from './selection.epics';

import {serviceCallMethodEpic, serviceCallRESTEpic, serviceExecuteSearchEpic, serviceFeatureTransactionEpic,serviceGetImageEpic} from './services.epics';
import {setEntriesVisibilityEpic} from './set.entries.visibility.epic';
import {setFilterHistoryTimestampEpic} from './set.filter.history.epic';
import {setGlobalParameterValueEpic} from './set.global.parameter.epic';

/**
 * @private
 * @hidden
 */
export const epics = combineEpics(
    initialiseEpic, enableFunctionalityEpic, disableFunctionalityEpic,
    listMapEventsEpic, addMarkersEpic, removeMarkersEpic, gotoMarkerEpic,
    zoomInEpic, zoomOutEpic, pantToEpic, gotoInitExtentEpic, gotoExtentEpic,
    gotoPointEpic, zoomToScaleEpic, setEntriesVisibilityEpic,
    setBaselayersVisibilityEpic, setComponentsStateEpic, resetSelectionEpic,
    addToSelectionEpic, removeFromSelectionEpic, reduxPromiseObservableEpic,
    setGlobalParameterValueEpic, setFilterHistoryTimestampEpic,
    dispatchDataRefreshEventEpic, serviceGetImageEpic, serviceCallMethodEpic,
    serviceCallRESTEpic, serviceFeatureTransactionEpic,
    serviceExecuteSearchEpic, registerExtensionEpic,
    addMenuItemEpic  // ADD EPIC HERE

);
